module.exports = __webpack_public_path__ + "img/02.93ab93b1.png";